// itg-40lb-weight-start

// var weight = Number($(document).find('.weight_text').text());
// console.log(weight);

var variantIdToAdd = "42539385487613"; 
var quantityToAdd = 1;

let cartDrawer = '';

let cartPage = document.querySelector('.template-cart');

if(document.querySelector('cart-drawer')){
  cartDrawer = document.querySelector('cart-drawer');
}else if(document.querySelector('cart-items')){
  cartDrawer = document.querySelector('cart-items');
}

var freeCartItem = {
    id: variantIdToAdd,
    quantity: quantityToAdd,
};


function freeGift(colQty) {
  if(!document.querySelector('.has_cooler')){
    freeCartItem.quantity = colQty;
    console.log('gift add js');
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(freeCartItem),
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((response) => {
        if(!document.querySelector('.has_cooler')){
          document.querySelector('cart-drawer').classList.add('has_cooler');
        }
        console.log(response);
        cartDrawer.renderContents(response);
        // location.reload();
    })
    .catch((error) => {
        console.error("Error adding free item to cart:", error);
    });
  }else{
    console.log('gift change js');
    freeCartItem.quantity = colQty;
    
    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(freeCartItem),
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((response) => {
      console.log(response);
      if(cartPage){
      setTimeout(function(){
      publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
      },3000);
      }else{
      cartDrawer.renderContents(response,true);
    }
        // location.reload();
    })
    .catch((error) => {
        console.error("Error adding free item to cart:", error);
    });
  }
}

function removeGift() {
    freeCartItem.quantity = 0;
    fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(freeCartItem),
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((response) => {
      if(document.querySelector('.has_cooler')){
        document.querySelector('.has_cooler').classList.remove('has_cooler');
      }
      console.log(response);
      if(cartPage){
      setTimeout(function(){
      publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
      },3000);
      }else{
      cartDrawer.renderContents(response,true);
    }

    const giftItem = Array.from(document.querySelectorAll('.cart-item')).find(item => item.dataset.variantId === freeCartItem.id);
      if (giftItem) {
        giftItem.classList.add('ctm_free_gift_item'); 
      }
      })
    .catch((error) => {
        console.error("Error removing free item from cart:", error);
    });
}





function checkWeight() {
  
let frozenWeight = 0;
let oldFrozenWeigth = 0;
let totalFrozen = 0;
  
const cartDrawer = document.querySelector('cart-drawer');
const cartItems = document.querySelector('cart-items');

if (cartDrawer && cartDrawer.dataset.frozenWeight) {
    frozenWeight = Number(cartDrawer.dataset.frozenWeight);
    oldFrozenWeigth = Number(cartDrawer.dataset.frozenWeight);
    totalFrozen = Number(cartDrawer.dataset.totalFrozen);
} else if (cartItems && cartItems.dataset.frozenWeight) {
    frozenWeight = Number(cartItems.dataset.frozenWeight);
    oldFrozenWeigth = Number(cartItems.dataset.frozenWeight);
    totalFrozen = Number(cartItems.dataset.totalFrozen)
}


 console.log(totalFrozen,frozenWeight, oldFrozenWeigth);
  if(document.querySelector('.cart-item') || document.querySelector('.cart-item')){
    totalFrozen = document.querySelector('.cart-item').dataset.final || document.querySelector('.cart-item').dataset.final;
  }else{
    if(document.querySelector('.has_cooler')){
      document.querySelector('.has_cooler').classList.remove('has_cooler');
    }
  }
  // if(totalFrozen > 40){
  //   frozenWeight = frozenWeight * 2;
  // }
  // if(totalFrozen <= 40){
  //   frozenWeight = oldFrozenWeigth;
  // }
 //  console.log(totalFrozen,frozenWeight);
 // // let colQty = totalFrozen/frozenWeight;
 //  let colQty = totalFrozen/45;
 //   console.log(colQty,'oldd');
 //  colQty = Number(colQty.toFixed(2).split('.')[0]);
 //  console.log(colQty,'old');
 //  if(totalFrozen < 45){
 //    colQty = colQty+1;
 //  }

  console.log(totalFrozen, frozenWeight);
  
let colQty = Math.ceil(totalFrozen / 45);
console.log(colQty, 'new');
  
  //console.log(colQty);
  
        console.log("Current cart weight (excluding coolers):", totalFrozen + " lb");
        console.log("Gift added status:");
        if (totalFrozen >= frozenWeight ) {
            console.log("Adding free gift to cart");
            freeGift(colQty);
        }
        else if (document.querySelector('.has_cooler') && totalFrozen < frozenWeight) {
            console.log("Removing free gift from cart");
            removeGift();
        } 
}

window.onload = function(){
    freeCartItem.sections = cartDrawer.getSectionsToRender().map((section) => section.id),
    freeCartItem.sections_url = window.location.pathname
    console.log(freeCartItem);
    console.log(freeCartItem.sections);

      //checkWeight();
      window.checkWeight();
}






// ner-end



// itg-40lb-weight-end


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
        var cartPage = document.querySelector('cart-drawer');
        if(cartPage){
        checkWeight();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll('.quantity__button').forEach((button) => button.classList.add('disabled'));

    if (document.querySelectorAll('.card--product card__add-to-cart button[name="add"]')) {
      document.querySelectorAll('.card--product .card__add-to-cart button[name="add"]').forEach(button => {
        button.setAttribute('aria-disabled', false);
        button.querySelector('span').classList.remove('hidden');
        button.querySelector('.sold-out-message').classList.add('hidden');
      });
    }
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.querySelectorAll('.quantity__button').forEach((button) => button.classList.remove('disabled'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.querySelectorAll('.quantity__button').forEach((button) => button.classList.remove('disabled'));
        this.disableLoading(line);
        checkWeight();
      });
  }

  updateLiveRegions(line, message) {

    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};